// Sentry wrapper. When REACT_APP_SENTRY_DSN is empty/undefined we export
// a no-op stub so local dev (and CI builds without a DSN secret) work
// identically to before — no init, no errors, no PII in transit.
import React from 'react';
import * as Sentry from '@sentry/react';

const DSN = process.env.REACT_APP_SENTRY_DSN;
const ENV = process.env.REACT_APP_SENTRY_ENV || 'development';
const RELEASE = process.env.REACT_APP_VERSION;

const enabled = Boolean(DSN);

function init() {
  if (!enabled) return;
  Sentry.init({
    dsn: DSN,
    environment: ENV,
    release: RELEASE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    // Replay disabled by design — keeps PII out of Sentry. Replay integration
    // is intentionally NOT imported.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
  });
}

function captureException(err) {
  if (!enabled) return;
  try {
    Sentry.captureException(err);
  } catch (_) {
    // Never let Sentry plumbing break the app.
  }
}

// When DSN is empty, ErrorBoundary becomes a pass-through that just renders
// children — preserving the old dev experience (errors propagate to React's
// default overlay rather than being swallowed).
const PassthroughBoundary = ({ children }) => React.createElement(React.Fragment, null, children);

const ErrorBoundary = enabled ? Sentry.ErrorBoundary : PassthroughBoundary;

export { init, captureException, ErrorBoundary };
